import ApiService from '../../services/api.service'
import { MfaConfigurationModel, UserPermissionsModel } from '../models'
import { stringToPermissions } from '../helpers'

export default {
  async currentUserFeatureSwitches(): Promise<string[]> {
    const response = await ApiService.get(`${ApiService.backendEnvironmentConfiguration().userSettingsApi}/FeatureSwitches/forUser`)
    return response.data.value
  },
  async currentUserPermissions(): Promise<UserPermissionsModel[]> {
    const response = await ApiService.get(`${ApiService.backendEnvironmentConfiguration().userSettingsApi}/Authorizations/forUser`)
    return response.data.map((p: any) => {
      return {
        id: p.objectId,
        name: p.permissionName,
        permissions: stringToPermissions(p.role),
      } as UserPermissionsModel
    })
  },
  async currentUserMfaConfiguration(): Promise<MfaConfigurationModel> {
    const response = await ApiService.get(`${ApiService.backendEnvironmentConfiguration().userSettingsApi}/Accounts/mfa/configuration`)
    return response.data
  },
  async updateMfaConfiguration(mfaConfiguration: MfaConfigurationModel): Promise<void> {
    await ApiService.put(`${ApiService.backendEnvironmentConfiguration().userSettingsApi}/Accounts/mfa/configuration`, mfaConfiguration)
  },
}
